import * as React from 'react';

type Props = {
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

type State = { hasError: boolean; message?: string };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : 'Unknown error',
    };
  }

  componentDidCatch(error: unknown) {
    // OWASP A02 — never log raw error.cause / payloads to console in prod.
    if (import.meta.env.DEV) {
      console.warn('ErrorBoundary caught', error);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="rounded-md border border-destructive/40 bg-destructive/5 p-4 text-sm text-destructive" data-testid="error-boundary-fallback">
            Something went wrong while rendering this section.
          </div>
        )
      );
    }
    return this.props.children;
  }
}
